/* unplugin-vue-components disabled */import script from "./confirmErrMsg.vue?vue&type=script&lang=ts&setup=true"
export * from "./confirmErrMsg.vue?vue&type=script&lang=ts&setup=true"

import "./confirmErrMsg.vue?vue&type=style&index=0&id=4fa843ee&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fa843ee"]])

export default __exports__